export default "__VITE_ASSET__Cw_4E51T__"